module.exports = __webpack_public_path__ + "static/media/male.29dd7497.jpg";